import useCollection from "./useCollection"

import { mutate } from "swr"
import API from "./api"

export default function useLayoutFields(layoutId) {
  const key = `/layouts/${layoutId}/fields`

  const fields = useCollection({ key })

  async function reorder(from, to) {
    await API.post(`/layouts/${layoutId}/reorder_fields`, { from, to })
    mutate(key)
  }

  fields.reorder = reorder

  return fields
}
